<template>
  <v-card>
    <v-card-title>
      {{ title || '' }}
    </v-card-title>
    <v-card-text>
      <div class="upload-file-form">
        <v-text-field outlined
                      :label="label"
                      v-model="value"></v-text-field>
      </div>
    </v-card-text>
    <v-card-actions class="text-right">
      <v-spacer></v-spacer>
      <v-btn text
             @click="$emit('submit', undefined)">
        {{ $t('cancel') }}
      </v-btn>
      <v-btn text
             color="primary"
             :disabled="!value"
             @click="$emit('submit', value)">
        {{ $t('ok') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

import {onMounted, ref} from "@vue/composition-api";

export default {
  name: 'TextInputDialog',
  props: {
    title: String,
    label: String,
    prefill: String,
  },
  setup(props) {
    const value = ref(null);

    onMounted(() => {
      value.value = props.prefill || null;
    })

    return {
      value,
    }
  }
}
</script>
